<button type="button" class="btn checkbox-container">
  <input
    type="checkbox"
    class="checkbox-input"
    [ngModel]="modelValue"
    (change)="updateCheckboxValue()"
    [id]="id"
  />
  <label
    [for]="id"
    class="checkbox-label animate-fade-in {{ labelClass }}"
  >
    {{ labelText }}
  </label>
</button>
